import { render, staticRenderFns } from "./t-input-product-list.vue?vue&type=template&id=a0cd44ca&"
import script from "./t-input-product-list.vue?vue&type=script&lang=js&"
export * from "./t-input-product-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports